<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <span><i class="fas fa-angle-right"></i></span>
      }

      @if (!status) {
        <span><i class="fas fa-angle-left"></i></span>
      }
    </div>
    <div class="sidebar-header">
      <h3>Tax Relief</h3>
    </div>

    <ul class="list-unstyled components">

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="decline-in-value">{{'NavMenu.DeclineinValue'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="prop19">{{'NavMenu.Transfer55Over'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="disabled-transfer">{{'NavMenu.Disabled'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="disaster-relief">{{'NavMenu.DisasterRelief'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="mills-act">{{'MillsAct.SearchTitle'|translate}}</a>
      </li>

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" routerLink="change-in-ownership-rescission">{{'ChangeAddressRescission.SearchTitle'|translate}}</a>
      </li>




    </ul>

  </nav>
  <div id="content">

    <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
    <i class="fas fa-align-left"></i>
    <span>Toggle Sidebar</span>
  </button> -->
  <router-outlet></router-outlet>
</div>


</div>
